/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * mailalliance App Distributor API
 * OpenAPI spec version: 1.0
 */
import { customAxios } from '../lib/axios';

import type {
  ApplicationDTO,
  BreadcrumbResponse,
  CreateFolderRequest,
  CreateFolderResponse,
  FolderChildrenResponse,
  LoginDTO,
  ReleaseChannelInfoDTO,
  ReleaseDownloadDTO,
  RenameRequest,
  SasUrlResponse,
  UpdateFileOrderRequest,
  UploadSasUrlResponse,
} from './dtos';

export const getMailallianceAppDistributorAPI = () => {
  /**
   * @summary Get all applications
   */
  const applicationsControllerGetApplications = () => {
    return customAxios<ApplicationDTO[]>({ url: `/applications`, method: 'GET' });
  };

  /**
   * @summary Get all applications
   */
  const applicationsControllerGetApplicationByName = (app: string) => {
    return customAxios<ApplicationDTO>({ url: `/applications/${app}`, method: 'GET' });
  };

  /**
   * @summary Get all release channels for a specific application
   */
  const applicationsControllerGetReleaseChannelsByApp = (app: string) => {
    return customAxios<string[]>({ url: `/applications/${app}/channels`, method: 'GET' });
  };

  /**
   * @summary Get the latest application release for a channel
   */
  const applicationsControllerGetAppReleaseChannelInfo = (app: string, channel: string) => {
    return customAxios<ReleaseChannelInfoDTO>({
      url: `/applications/${app}/channels/${channel}`,
      method: 'GET',
    });
  };

  /**
   * @summary Download a specific application release
   */
  const downloadsControllerServeReleaseDownload = (app: string, filename: string) => {
    return customAxios<ReleaseDownloadDTO>({
      url: `/applications/${app}/download/${filename}`,
      method: 'GET',
    });
  };

  /**
   * @summary Download a specific channel yml for auto-update
   */
  const downloadsControllerServeAutoUpdateFile = (app: string, filename: string) => {
    return customAxios<void>({
      url: `/applications/${app}/auto-update/${filename}`,
      method: 'GET',
    });
  };

  /**
   * @summary Login
   */
  const authControllerLogin = (loginDTO: LoginDTO) => {
    return customAxios<void>({
      url: `/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loginDTO,
    });
  };

  /**
   * @summary Get user information
   */
  const usersControllerGetUserInfo = () => {
    return customAxios<void>({ url: `/users/me`, method: 'GET' });
  };

  /**
   * @summary List all immediate subfolders and files in a folder
   */
  const blobStorageControllerGetFolderChildren = (folderPath: string) => {
    return customAxios<FolderChildrenResponse>({
      url: `/blob-storage/folders/${folderPath}/children`,
      method: 'GET',
    });
  };

  /**
   * @summary Get breadcrumb trail for a folder
   */
  const blobStorageControllerGetBreadcrumb = (folderPath: string) => {
    return customAxios<BreadcrumbResponse>({
      url: `/blob-storage/folders/${folderPath}/breadcrumb`,
      method: 'GET',
    });
  };

  /**
   * @summary Create a new subfolder
   */
  const blobStorageControllerCreateFolder = (
    parentFolderPath: string,
    createFolderRequest: CreateFolderRequest
  ) => {
    return customAxios<CreateFolderResponse>({
      url: `/blob-storage/folders/${parentFolderPath}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createFolderRequest,
    });
  };

  /**
   * @summary Delete a folder and all its contents
   */
  const blobStorageControllerDeleteFolder = (folderPath: string) => {
    return customAxios<void>({ url: `/blob-storage/folders/${folderPath}`, method: 'DELETE' });
  };

  /**
   * @summary Get a SAS URL for downloading a file
   */
  const blobStorageControllerGetDownloadSasUrl = (filePath: string) => {
    return customAxios<SasUrlResponse>({
      url: `/blob-storage/download-sas-url/${filePath}`,
      method: 'GET',
    });
  };

  /**
   * @summary Get a SAS URL for uploading a file
   */
  const blobStorageControllerGetUploadSasUrl = (filePath: string) => {
    return customAxios<UploadSasUrlResponse>({
      url: `/blob-storage/upload-sas-url/${filePath}`,
      method: 'GET',
    });
  };

  /**
   * @summary Delete a file
   */
  const blobStorageControllerDeleteFile = (filePath: string) => {
    return customAxios<void>({ url: `/blob-storage/files/${filePath}`, method: 'DELETE' });
  };

  /**
   * @summary Update manual file order
   */
  const blobStorageControllerUpdateFileOrder = (
    folderPath: string,
    updateFileOrderRequest: UpdateFileOrderRequest
  ) => {
    return customAxios<void>({
      url: `/blob-storage/folders/${folderPath}/files/order`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateFileOrderRequest,
    });
  };

  /**
   * @summary Rename a file
   */
  const blobStorageControllerRenameFile = (filePath: string, renameRequest: RenameRequest) => {
    return customAxios<void>({
      url: `/blob-storage/files/${filePath}/rename`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: renameRequest,
    });
  };

  /**
   * @summary Rename a folder
   */
  const blobStorageControllerRenameFolder = (folderPath: string, renameRequest: RenameRequest) => {
    return customAxios<void>({
      url: `/blob-storage/folders/${folderPath}/rename`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: renameRequest,
    });
  };

  return {
    applicationsControllerGetApplications,
    applicationsControllerGetApplicationByName,
    applicationsControllerGetReleaseChannelsByApp,
    applicationsControllerGetAppReleaseChannelInfo,
    downloadsControllerServeReleaseDownload,
    downloadsControllerServeAutoUpdateFile,
    authControllerLogin,
    usersControllerGetUserInfo,
    blobStorageControllerGetFolderChildren,
    blobStorageControllerGetBreadcrumb,
    blobStorageControllerCreateFolder,
    blobStorageControllerDeleteFolder,
    blobStorageControllerGetDownloadSasUrl,
    blobStorageControllerGetUploadSasUrl,
    blobStorageControllerDeleteFile,
    blobStorageControllerUpdateFileOrder,
    blobStorageControllerRenameFile,
    blobStorageControllerRenameFolder,
  };
};

type AwaitedInput<T> = PromiseLike<T> | T;

// eslint-disable-next-line no-redeclare
type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type ApplicationsControllerGetApplicationsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['applicationsControllerGetApplications']
    >
  >
>;
export type ApplicationsControllerGetApplicationByNameResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getMailallianceAppDistributorAPI
      >['applicationsControllerGetApplicationByName']
    >
  >
>;
export type ApplicationsControllerGetReleaseChannelsByAppResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getMailallianceAppDistributorAPI
      >['applicationsControllerGetReleaseChannelsByApp']
    >
  >
>;
export type ApplicationsControllerGetAppReleaseChannelInfoResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getMailallianceAppDistributorAPI
      >['applicationsControllerGetAppReleaseChannelInfo']
    >
  >
>;
export type DownloadsControllerServeReleaseDownloadResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['downloadsControllerServeReleaseDownload']
    >
  >
>;
export type DownloadsControllerServeAutoUpdateFileResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['downloadsControllerServeAutoUpdateFile']
    >
  >
>;
export type AuthControllerLoginResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getMailallianceAppDistributorAPI>['authControllerLogin']>>
>;
export type UsersControllerGetUserInfoResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getMailallianceAppDistributorAPI>['usersControllerGetUserInfo']>
  >
>;
export type BlobStorageControllerGetFolderChildrenResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerGetFolderChildren']
    >
  >
>;
export type BlobStorageControllerGetBreadcrumbResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerGetBreadcrumb']
    >
  >
>;
export type BlobStorageControllerCreateFolderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerCreateFolder']
    >
  >
>;
export type BlobStorageControllerDeleteFolderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerDeleteFolder']
    >
  >
>;
export type BlobStorageControllerGetDownloadSasUrlResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerGetDownloadSasUrl']
    >
  >
>;
export type BlobStorageControllerGetUploadSasUrlResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerGetUploadSasUrl']
    >
  >
>;
export type BlobStorageControllerDeleteFileResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerDeleteFile']
    >
  >
>;
export type BlobStorageControllerUpdateFileOrderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerUpdateFileOrder']
    >
  >
>;
export type BlobStorageControllerRenameFileResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerRenameFile']
    >
  >
>;
export type BlobStorageControllerRenameFolderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getMailallianceAppDistributorAPI>['blobStorageControllerRenameFolder']
    >
  >
>;
